import React from 'react';
import { useDispatch } from 'react-redux';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';
import { setModalOpen } from '../../../stores/actions/modal';
import Socket from '../../../connection/socket';

interface Props {
	socket: Socket | null;
	onsiteLocationId: number;
	session: string;
	handlePublish?: () => void;
}

export default function MultiOnsiteLocation({
	socket,
	onsiteLocationId,
	session,
	handlePublish = () => {},
}: Props) {
	const dispatch = useDispatch();

	function handleClose() {
		dispatch(setModalOpen(false));
	}

	function handleJoin() {
		handlePublish();
		socket?.sendMessage('kick-onsite-location-publishers', {
			fromOnsiteLocationId: onsiteLocationId,
			fromSession: session,
		});
		handleClose();
	}

	return (
		<MultiButtonConfirmationModal
			headerText="Location already active"
			bodyText="You can’t join a location from multiple devices"
			firstButtonText="Join here instead"
			firstButtonAction={handleJoin}
			secondButtonText="Close"
			secondButtonAction={handleClose}
			className="multi-onsite-confirmation"
			isOpen
		/>
	);
}
